module.exports = __webpack_public_path__ + "img/icon-resident.fa4efdcd.svg";